import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { CardSection } from 'legacyComponents/layout/cardSection';
import { ThreadCard } from 'legacyComponents/cards/types/thread';

@withNamespaces()
@inject('routerStore')
@observer
export class ChannelThreads extends React.Component {
  render() {
    const { threads } = this.props;

    return (
      <CardSection
        title='Threads'
        subTitle={' '}
        updateHeader
        index={0}
        isChannel
        ownerName=''
        cardApp={threads}
        CardComponent={ThreadCard}
        noDataCardType='forumThreads'
      />
    );
  }
}

ChannelThreads.propTypes = {
  threads: PropTypes.object,
};
